"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOverlay = exports.StyledGroupLabel = exports.StyledItemTextWrapper = exports.StyledItem = exports.StyledItemIndicator = exports.StyledContent = exports.StyledPlaceholder = exports.StyledValueWrapper = exports.StyledTrigger = void 0;
const react_select_1 = require("@radix-ui/react-select");
const styled_components_1 = __importStar(require("styled-components"));
const styles_1 = require("../../../styles");
const Tokens = __importStar(require("../../../styles/tokens"));
const { SIZES, BORDERS, BORDER_ALTERNATIVE, COLOURS, TYPOGRAPHY } = Tokens;
const { cloud, dishwater, night, silver, stone, white } = COLOURS.greyscale;
const { blue, red } = COLOURS.primary;
exports.StyledTrigger = (0, styled_components_1.default)(react_select_1.Trigger) `
    width: 100%;
    ${({ dimension }) => `padding: ${dimension === "medium" ? SIZES[1] : SIZES[1.5]};`};
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: relative;

    ${TYPOGRAPHY.body.base}
    ${TYPOGRAPHY.body.mobile}
    text-align: left;

    margin: 0;

    background-color: ${white};
    border: none;
    border-radius: ${BORDERS.radius};
    box-shadow: ${(0, styles_1.setBoxShadow)(silver)};

    &::before {
        ${BORDER_ALTERNATIVE}
        border: ${(0, styles_1.setBorderColour)(silver)};
        border-radius: ${BORDERS.radius};
    }

    &:hover,
    &:focus,
    &[aria-expanded="true"] {
        &::before {
            box-shadow: ${(0, styles_1.setBoxShadow)(night)};
            border: ${(0, styles_1.setBorderColour)(night)};
        }
    }

    &[aria-expanded="true"] {
        &::before {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
    }

    &:hover:disabled::before,
    &:focus:disabled::before {
        box-shadow: ${(0, styles_1.setBoxShadow)(silver)};
        border: ${(0, styles_1.setBorderColour)(silver)};
    }

    &:focus::after {
        content: "";
        box-shadow: 0 0 0 4px ${blue[50]};
        border-radius: ${BORDERS.radius};
        position: absolute;
        inset: -1px;
    }

    &:disabled,
    &[disabled] {
        background-color: ${dishwater};
        pointer-events: none;
    }

    /* Error state styles */
    ${({ $error }) => $error
    ? (0, styled_components_1.css) `
                  background-color: ${red[5]};
                  border: ${(0, styles_1.setBorderColour)(red[75])};
                  box-shadow: ${(0, styles_1.setBoxShadow)(red[75])};

                  &:hover,
                  &:focus {
                      box-shadow: ${(0, styles_1.setBoxShadow)(red[75])};
                  }
              `
    : ""}
`;
exports.StyledValueWrapper = styled_components_1.default.span `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
exports.StyledPlaceholder = styled_components_1.default.span `
    font-style: italic;
    color: ${stone};
`;
exports.StyledContent = (0, styled_components_1.default)(react_select_1.Content) `
    width: var(--radix-select-trigger-width);
    max-height: var(--radix-select-content-available-height);
    background-color: ${white};
    border: ${(0, styles_1.setBorderColour)(night)};
    overflow: hidden;
    border-bottom-left-radius: ${BORDERS.radius};
    border-bottom-right-radius: ${BORDERS.radius};
    ${TYPOGRAPHY.body.base}
`;
exports.StyledItemIndicator = (0, styled_components_1.default)(react_select_1.ItemIndicator) `
    position: absolute;
    top: 0;
    left: 0;
    border-left: ${`3px solid ${blue[100]}`};
    background: ${blue[5]};
    width: 100%;
    height: 100%;
`;
exports.StyledItem = (0, styled_components_1.default)(react_select_1.Item) `
    background-color: ${white};
    padding: ${SIZES[1]} ${SIZES[1.5]};
    border-top: solid 0.5px ${silver};
    border-bottom: solid 0.5px ${silver};
    cursor: pointer;
    position: relative;
    ${({ disabled }) => (disabled ? `color: ${stone};` : "")}

    &:focus, &:focus-visible {
        background: ${blue[5]};
        border-radius: 0;
        outline: none;
        border-top: solid 0.5px ${blue[50]};
        border-bottom: solid 0.5px ${blue[50]};
    }

    &:focus::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        border-left: ${`3px solid ${blue[100]}`};
        width: 100%;
        height: 100%;
    }
`;
exports.StyledItemTextWrapper = styled_components_1.default.span `
    position: relative;
`;
exports.StyledGroupLabel = (0, styled_components_1.default)(react_select_1.Label) `
    background-color: ${cloud};
    text-transform: uppercase;
    font-weight: 700;
    font-size: ${SIZES[1.5]};
    padding: ${SIZES[0.5]} ${SIZES[1.5]};
    border-top: ${(0, styles_1.setBorderColour)(silver)};
    border-bottom: ${(0, styles_1.setBorderColour)(silver)};
`;
/**
 * The overlay is used to prevent the user from interacting
 * with the rest of the page while the dropdown is open.
 * This is a workaround for an open bug in the Radix Select component
 * https://github.com/radix-ui/primitives/issues/1658#issuecomment-1307242344
 */
exports.StyledOverlay = styled_components_1.default.div `
    position: fixed;
    inset: 0;

    /* Choose whatever z-index makes most sense to you */
    z-index: 1050;
    isolation: isolate;
`;
//# sourceMappingURL=Select.styles.js.map